<div class="mat-form-field-outline mat-form-field-outline-thick">
    <div class="payment" [ngClass]="isDesktop ? 'desktop': 'mobile'" fxLayoutAlign="start center" fxLayout="row">
        <div *ngIf="!selectedPayment else paymentpresentation" class="empty"><span i18n>loading</span>...</div>
        <ng-template #paymentpresentation>
            <div class="image" fxLayoutAlign="start center"><img [src]="isDesktop ? selectedPayment.thumbnail?.url : selectedPayment.thumbnailMobile?.url || selectedPayment.thumbnail?.url" /></div>
        </ng-template>
        <div class="select-icon">
            <img src="{{licenceService.getKey('icon-arrow-down')}}" alt="icon-arrow-down" class="s">
        </div>
    </div>
</div>
